import React from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/styles/components/MenuInternal.sass';

const MenuCaldas = () => (
  <div className="row MenuInternal -caldas">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className="MenuInternal__list">
            {/* <li className="MenuInternal__list--item">
              <NavLink to="/caldas/registro">
                REGISTRO
              </NavLink>
            </li> */}
            <li className="MenuInternal__list--item">
              <NavLink to="/caldas/acerca-de-la-carrera">
                SERIES CALDAS RESUMEN
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink id="que-incluye" to="/caldas/precios-que-incluye">
                PRECIOS Y QUÉ INCLUYE
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/caldas/categorias-y-rutas">
                CATEGORÍAS Y RUTAS
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/caldas/premiacion-y-reglamento">
                PREMIACIÓN Y REGLAMENTO
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/caldas/patrocinio-expo">
                PATROCINIO Y EXPO
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/caldas/galeria">
                GALERIA
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/caldas/resultados">
                RESULTADOS
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)
  
export default MenuCaldas;